import React from "react";
import ResetPassword from "../../components/RecoverPassword/RecoverPassword";

const RecoverPasswordPage: React.FC = () => {
  return (
      <ResetPassword />
  );
};

export default RecoverPasswordPage;